import { CampaignStepErrorsInterface } from 'modules/campaigns/campaign-steps/types/campaign-step-error-response-interface'

export const campaignStepDefaultErrors: CampaignStepErrorsInterface = {
  body: '',
  fromEmail: '',
  fromName: '',
  subject: '',
  previewText: '',
  attachments: '',
  stepBefore: '',
  delayValue: '',
  timeOfTheDay: '',
  excludedWeekdays: '',
  common: [],
}
